import axios from 'axios'


// URL base dell'API per i bilanci partecipativi, recuperato dall'env file

const BILANCIO_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'bilancio-partecipativo'

// Definizione dell'header per le richieste con JSON
const headers = { 'Content-Type': 'application/json' }


class BilancioPartecipativoService {

    /**
     * Recupera tutti i bilanci partecipativi disponibili nel sistema.
     * Effettua una richiesta GET a `/bilancio-partecipativo/all`.
     *
     * @returns {Promise} - Una promessa che restituisce la lista di tutti i bilanci partecipativi.
     */
    getAll() {
        return axios.get(BILANCIO_REST_API_URL + "/all");
    }

    /**
     * Recupera tutti i bilanci partecipativi associati a un determinato comune.
     * Effettua una richiesta GET a `/bilancio-partecipativo/comune/{comId}`.
     *
     * @param {number} comId - L'ID del comune per cui recuperare i bilanci partecipativi.
     * @returns {Promise} - Una promessa che restituisce la lista dei bilanci del comune specificato.
     */
    getAllByComune(comId) {
        return axios.get(BILANCIO_REST_API_URL + "/comune/" + comId);
    }

    /**
     * Recupera un bilancio partecipativo specifico in base al suo ID.
     * Effettua una richiesta GET a `/bilancio-partecipativo/{bilId}`.
     *
     * @param {number} bilId - L'ID del bilancio partecipativo da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli del bilancio partecipativo.
     */
    getBilancio(bilId) {
        return axios.get(BILANCIO_REST_API_URL + `/${bilId}`)
    }
    /**
     * Salva o aggiorna un bilancio partecipativo nel sistema.
     * Effettua una richiesta POST a `/bilancio-partecipativo/save` con i dati del bilancio.
     *
     * @param {Object} bilancio - Oggetto contenente i dettagli del bilancio partecipativo da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveBilancio(bilancio) {
        return axios.post(BILANCIO_REST_API_URL + "/save", bilancio, headers)
    }
}

// Creazione dell'istanza per essere importata direttamente nei componenti
const bilancioPartecipativoServiceInstance = new BilancioPartecipativoService();
export default bilancioPartecipativoServiceInstance;